import React from 'react';
import { Card, Form, Input, Button, Switch, Typography, Space, message } from 'antd';

const { Text } = Typography;

const SecuritySettings = () => {
  const [form] = Form.useForm();

  const onFinish = (values) => {
    message.success('Password updated successfully');
    form.resetFields();
  };

  return (
    <Space direction="vertical" style={{ width: '100%' }} size="large">
      <Card title="Change Password" bordered={false}>
        <Form
          form={form}
          layout="vertical"
          onFinish={onFinish}
        >
          <Form.Item
            name="currentPassword"
            label="Current Password"
            rules={[{ required: true, message: 'Please input your current password!' }]}
          >
            <Input.Password />
          </Form.Item>

          <Form.Item
            name="newPassword"
            label="New Password"
            rules={[
              { required: true, message: 'Please input your new password!' },
              { min: 6, message: 'Password must be at least 6 characters' }
            ]}
          >
            <Input.Password />
          </Form.Item>

          <Form.Item
            name="confirmPassword"
            label="Confirm New Password"
            dependencies={['newPassword']}
            rules={[
              { required: true, message: 'Please confirm your new password!' },
              ({ getFieldValue }) => ({
                validator(_, value) {
                  if (!value || getFieldValue('newPassword') === value) {
                    return Promise.resolve();
                  }
                  return Promise.reject(new Error('The two passwords that you entered do not match!'));
                },
              }),
            ]}
          >
            <Input.Password />
          </Form.Item>

          <Form.Item>
            <Button type="primary" htmlType="submit">
              Update Password
            </Button>
          </Form.Item>
        </Form>
      </Card>

      <Card title="Two-Factor Authentication" bordered={false}>
        <Space direction="vertical">
          <Space>
            <Switch />
            <Text>Enable Two-Factor Authentication (2FA)</Text>
          </Space>
          <Text type="secondary">
            Add an extra layer of security to your account by requiring a verification code in addition to your password.
          </Text>
        </Space>
      </Card>
    </Space>
  );
};

export default SecuritySettings;
